import { useEffect, useMemo, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _single, _UBLInvoice } from "../../../../../core/services/dataBean/EntityCatalog";
import usePaginator from "../../../../theme/Component/usePaginator";
import { toast } from "react-toastify";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { AccountEditor } from "../../../../editor/AccountEditor";
import { YearSelector } from "../../../../../core/shared/inputs/YearSelector";
import { MonthConstantsEditor } from "../../../../RemoteAbstractAction/editors/MonthConstantsEditor";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { Modal } from "../../../../theme/Component/Modal";
import { InputDate } from "../../../../theme/Input/InputDate";
import { FileInput } from "../../../../theme/Component/FileInput";
import { SelectBusinessCore } from "../../../../erp/cellEditor/BusinessCore/SelectBusinessCore";
import { SelectProject } from "../../../../erp/cellEditor/BudgetAccountantOperation/SelectProject";
import { SelectDocumentStateConstants } from "../../../../contabilidad/CatalogoDocumentosUBL/Selectores/SelectDocumentStateConstants";
import { BasicSwitch } from "../../../../theme/Component/BasicSwitch";
import { SelectSupplierPaymentTypeConstants } from "./Component/SelectSupplierPaymentTypeConstants";
import { ThirdBankingAccountEditor } from "../../../../Talentohumano/ParametrosTalentoHumano/ThirdBankingAccount/ThirdBanking.editor";
import { SelectAccountantConceptCatalogForSupplierInvoice } from "../ublinvoice/SelectAccountantConceptCatalogForSupplierInvoice";
import useModal, { MODAL_LG, MODAL_md } from "../../../../theme/Component/hooks/useModal";
import { useUBLInvoiceActions } from "../ublinvoice/hooks/useUBLInvoiceActions";
import { ImportUBLInvoice } from "../ublinvoice/ImportUBLInvoice";

export interface DocumentPDF {
    MediaContext: string;
    Media: string;
    Filename: string;
    Type: string;
    URLLink: string | null;
}

interface formIni {
    IDAccountSupplier: number;
    IDCustomer: number;
    UBLDocumentType: number;
    Year: number;
    Month: number;
    State: number;

}
interface Props {
    isChash?: boolean;
    externaUBLS?: any;
    embedded?: boolean;
    initialInvoice?: any;
    onSaved?: (invoice?: any) => void;
}

export const UBLInvoiceSupplier = ({ isChash, externaUBLS, embedded = false, initialInvoice, onSaved }: Props) => {

    const { instance, bean, setBean, lista, setLista, isMissing, validateForm, isRequired, addRequiredFields } = useDataBean(_UBLInvoice);
    const paginador = usePaginator();
    const importUBL = useModal("Importar Factura Electrónica", MODAL_md);

    const [form, setForm] = useState<Partial<formIni>>({
        Year: _single.getCurrenYear(),
        State: 9,
    })


    const registers = 15;

    useEffect(() => {
        if (!embedded && form.Year) {
            getLista()
        }
    }, [paginador.page])

    useEffect(() => {
        if (!initialInvoice) return;

        setBean(initialInvoice);
    }, [initialInvoice]);

    useEffect(() => {
        const requiredFields = [
            "PaymentType",
            "IDAccountSupplier",
            "AccountantDate",
            "IDThirdBankingAccount",
            "IDAccountantConcept",
            "IssueDate",
            ...(bean.PaymentType === 18 ? ["IDBusinessCore", "IDProject"] : []),
        ];

        addRequiredFields(requiredFields);
    }, [bean.PaymentType]);

    const getLista = () => {
        if (externaUBLS) {
            let cant = 1;
            let pag = cant > 15 ? cant / 15 : 1;
            paginador.setPages(pag);
            paginador.setRecords(cant);
            paginador.setRegiPerPage(registers)
            try {

                externaUBLS.forEach(element => {
                    element.DataBeanProperties.FCEntity = `${element.DataBeanProperties.FCIDDocument ? `${element.DataBeanProperties.FCMnemonic} - ${element.DataBeanProperties.FCConsecutive}` : ""}`
                    element.DataBeanProperties.OBEntity = `${element.DataBeanProperties.OBIDDocument ? `${element.DataBeanProperties.OBMnemonic} - ${element.DataBeanProperties.OBConsecutive}` : ""}`
                    element.DataBeanProperties.TaxEntity = `${element.DataBeanProperties.IDTaxSchemeValueForTaxHold ? `${element.DataBeanProperties.TaxSchemeCode} - ${element.DataBeanProperties.TaxSchemeName}` : ""}`
                });
            } catch (error) {

            }
            setLista(externaUBLS);

        } else {
            instance.getUblInvoiceCatalogProductionOrder(null, form.IDCustomer, 0, form.Year, form.Month, form.State, null, paginador.page, registers).then(
                (resp) => {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (registers ?? 15));
                    paginador.setRegiPerPage(registers)
                    resp.List.forEach(element => {
                        element.DataBeanProperties.FCEntity = `${element.DataBeanProperties.FCIDDocument ? `${element.DataBeanProperties.FCMnemonic} - ${element.DataBeanProperties.FCConsecutive}` : ""}`
                        element.DataBeanProperties.OBEntity = `${element.DataBeanProperties.OBIDDocument ? `${element.DataBeanProperties.OBMnemonic} - ${element.DataBeanProperties.OBConsecutive}` : ""}`
                        element.DataBeanProperties.TaxEntity = `${element.DataBeanProperties.IDTaxSchemeValueForTaxHold ? `${element.DataBeanProperties.TaxSchemeCode} - ${element.DataBeanProperties.TaxSchemeName}` : ""}`
                    });
                    setLista(resp.List);
                }
            ).catch(
                err => { console.log(err) }
            )
        }
    }

    const modal = useModal("", MODAL_LG);
    const [modalDocument, setModalDocument] = useState<any>({ view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const modalConfig = useModal("Especificar Divisa", MODAL_md)
    const modalConfig2 = useModal("Terminos de Pago", MODAL_md)
    const [modalApplyPrepaid, setModalApplyPrepaid] = useState<any>({ view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalEdit, setModalEdit] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalEditPayment, setModalEditPayment] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const create = () => {
        setBean({
            IsDocumentSupport: false,
            IDAccountantConcept: null,
        });
        modal.open("Crear Factura de Proveedores");
    }

    const { listButtons: ublInvoiceActionButtons, actionModals: ublInvoiceActionModals, head: ublInvoiceHead } = useUBLInvoiceActions({
        invoice: bean,
        actionKeys:
            [
                "edit",
                "items",
                "withholdingTaxes",
                "accountingDocuments",
                "invoiceDocument",
                "payments",
                "events",
                "crossPrepaid",
                "applyPrepaid",
                "contingency",
                "setAsSale",
                "proforma",
                "description",
                "accountantConcept",
                "paymentTerms",
                "currency",
                "createAccounting",
                "fireElectronicDocument",
                "adjustmentNotes",
                "radianEvents",
                "duplicate",
                "xml",
                "notifyEmail",
                "notifySiif",
                "fixedAssetEntry",
                "invoiceAttachment",
                "nullify",
                "paymentType",
                "accountingDocument",
                "fixedAssetDocument",
                "obligationDocument",
                "relatedDocument",
                "discrepancyResponse",
            ]
        ,
        canView: _single.canView(),
        canDelete: true,
        onChange: () => { getLista() },
        useSupplierPaymentType: true,
        isCash: isChash ?? false,
        onEdit: () => modal.open("Editar Factura de Proveedores")
    });
    const importElectronicInvoice = () => {
        importUBL.open();
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create },
        { nombre: 'Importar Factura Electrónica', visible: _single.canCreate(), icono: 'ri-upload-cloud-2-line', evento: importElectronicInvoice },
    ]


    const formUBL = () => {
        return (
            <div className="row">

                <div className="col-md-6">
                    <label className={`${isMissing('PaymentType') ? 'has-error' : ''}`}>Tipo de Pago {isRequired('PaymentType') ? <span className="text-danger">*</span> : ''}</label>
                    <SelectSupplierPaymentTypeConstants idSelector={bean.PaymentType} onChange={(e) => { setBean({ ...bean, "PaymentType": e, "IDBusinessCore": null, "IDProject": null }) }} label=" " />
                </div>

                <div className="col-md-6">
                    <label className={`${isMissing('AccountantDate') ? 'has-error' : ''}`}>Fecha de registro contable {isRequired('AccountantDate') ? <span className="text-danger">*</span> : ''}</label>
                    <InputDate label=" " name="date" value={bean.AccountantDate} setDate={(e) => { setBean({ ...bean, "AccountantDate": e }) }} />
                </div>

                {bean.PaymentType === 18 &&
                    <>
                        <div className="col-md-6">
                            <label className={`${isMissing('IDProject') ? 'has-error' : ''}`}>Proyecto {isRequired('IDProject') ? <span className="text-danger">*</span> : ''}</label>
                            <SelectProject
                                label=" "
                                idSelector={bean.IDProject}
                                onChange={(value) => {
                                    if (!value) {
                                        setBean({
                                            ...bean,
                                            IDProject: null,
                                            IDBusinessCore: null
                                        });
                                        return;
                                    }

                                    const { IDProject, IDBusinessCore } = value;
                                    setBean({
                                        ...bean,
                                        IDProject: IDProject ?? null,
                                        IDBusinessCore: IDBusinessCore ?? null
                                    });
                                }}
                                returnType="Object"
                            />

                        </div>
                        <div className="col-md-6">
                            <label className={`${isMissing('IDBusinessCore') ? 'has-error' : ''}`}>Línea de Negocio {isRequired('IDBusinessCore') ? <span className="text-danger">*</span> : ''}</label>
                            <SelectBusinessCore returnType="ID" idSelector={bean.IDBusinessCore} label=" " onChange={(e) => { setBean({ ...bean, "IDBusinessCore": e }) }} />
                        </div>
                    </>
                }
                <div className="col-md-6">
                    <label className={`${isMissing('IDAccountSupplier') ? 'has-error' : ''}`}>Proveedor {isRequired('IDAccountSupplier') ? <span className="text-danger">*</span> : ''}</label>
                    <AccountEditor idAccount={bean.IDAccountSupplier} label=" " onChange={(e) => { setBean({ ...bean, "IDAccountSupplier": e.IDAccount }) }} />
                </div>

                {bean.IDAccountSupplier &&
                    <div className="col-md-6">
                        <label className={`${isMissing('IDThirdBankingAccount') ? 'has-error' : ''}`}>Destino de Pago {isRequired('IDThirdBankingAccount') ? <span className="text-danger">*</span> : ''}</label>
                        <ThirdBankingAccountEditor label=" " idSelector={bean.IDThirdBankingAccount} idselectorAccount={bean.IDAccountSupplier} onChange={(e) => { setBean({ ...bean, "IDThirdBankingAccount": e }) }} />
                    </div>
                }

                <div className="col-md-6">
                    <label className={`${isMissing('IDAccountantConcept') ? 'has-error' : ''}`}>Concepto de Ingreso {isRequired('IDAccountantConcept') ? <span className="text-danger">*</span> : ''}</label>
                    <SelectAccountantConceptCatalogForSupplierInvoice label=" " idSelector={bean.IDAccountantConcept} onChange={(e) => { setBean({ ...bean, "IDAccountantConcept": e }) }} />
                </div>

                <div className="col-md-6">
                    <label>Número de la Factura de Proveedor</label>
                    <input type="text" className="form-control" value={bean.InvoiceID} onChange={(e) => { setBean({ ...bean, "InvoiceID": e.target.value }) }} />
                </div>

                <div className="col-md-6">
                    <BasicSwitch estado={bean.IsDocumentSupport} eventChange={(e) => { setBean({ ...bean, "IsDocumentSupport": e }) }} label="Documento Físico" />
                </div>

                <div className="col-md-6">
                    <label className={`${isMissing('IssueDate') ? 'has-error' : ''}`}>Fecha Remisión {isRequired('IssueDate') ? <span className="text-danger">*</span> : ''}</label>
                    <InputDate label=" " name="date" value={bean.IssueDate} setDate={(e) => { setBean({ ...bean, "IssueDate": e }) }} />
                </div>

                <div className="col-md-6">
                    <FileInput
                        onCreate={(e) => { setBean({ ...bean, "Media": e.Media, "MediaContext": e.MediaContext }) }}
                        Media={bean.Media}
                        MediaContext={bean.MediaContext}
                    />
                </div>

                <div className="col-md-12">
                    <label>Observaciones</label>
                    <textarea className="form-control" value={bean.Observations} onChange={(e) => { setBean({ ...bean, "Observations": e.target.value }) }}></textarea>
                </div>
            </div >
        )
    }

    const validateData = () => {
        if (!validateForm()) {
            toast.error("Faltan Campos Obligatorios por diligenciar");
            return;
        }

        if (bean.IDUBLInvoice) {
            updateUBL();
        } else {
            generate();
        }
    }

    const generate = () => {
        instance.createPurchaseUBLInvoice(bean.PaymentType, bean.AccountantDate, bean.IDAccountSupplier, bean.IDThirdBankingAccount, bean.OdIDocument, bean.IDAccountantConcept, bean.InvoiceID, bean.IsDocumentSupport, bean.IssueDate, bean.Media, bean.MediaContext, _single.getAccountID(), bean.Observations, bean.IDBusinessCore, bean.IDProject).then(
            (resp: any) => {
                getLista();
                modal.close();
            }
        ).catch(err => { toast.error(err) });
    }

    const updateUBL = () => {
        if (bean.ApplyPrepaidValue) {
            if (!bean.PrepaidIDAccountantStr || bean.PrepaidIDAccountantStr.trim() === "") {
                toast.error("Debe seleccionar la cuenta contable del anticipo.");
                return;
            }
            if (!bean.PrepaidPayment || isNaN(bean.PrepaidPayment) || bean.PrepaidPayment <= 0) {
                toast.error("Debe ingresar un valor válido del anticipo.");
                return;
            }
        }

        instance.updateUBLInvoice(bean).then(
            (resp) => {
                if (!embedded) {
                    getLista();
                }
                modal.close();
                setModalApplyPrepaid({ ...modalApplyPrepaid, "view": false });
                setModalDocument({ ...modalDocument, view: false });
                modalConfig.close();
                modalConfig2.close();
                setModalEdit({ ...modalEdit, "view": false });
                setModalEditPayment({ ...modalEditPayment, "view": false });
                if (!embedded) {
                    getLista();
                }
                onSaved?.(resp);
            }
        ).catch(err => { console.log(err) })
    }

    

    if (embedded) {
        return (
            <>
                {formUBL()}
                <div className="row">
                    <div className="col-md-6 mt-4">
                        <BasicButton eventClick={validateData} icon="ri-save-line" children={bean.IDUBLInvoice ? "Actualizar" : "Crear Factura"} />
                    </div>
                </div>
            </>
        )
    }

    return (
        <BasicPage titulo="Facturas de proveedor">
            <div className="row">
                {!isChash &&
                    <>
                        <div className="col-md-6">
                            <AccountEditor idAccount={form.IDCustomer} label="Cliente" onChange={(e) => { setForm({ ...form, "IDCustomer": e.IDAccount }) }} />
                        </div>
                        <div className="col-md-6">
                            <YearSelector onChange={(e) => { setForm({ ...form, "Year": e }) }} value={form.Year} tittle="Vigencia" />
                        </div>
                        <div className="col-md-6">
                            <MonthConstantsEditor idSelect={form.Month} name="" onChange={(e) => { setForm({ ...form, "Month": e }) }} label="Mes" />
                        </div>
                        <div className="col-md-6">
                            <SelectDocumentStateConstants idSelect={form.State} onChange={(e) => { setForm({ ...form, "State": e }) }} label="Estado" />
                        </div>
                        <div className="col-md-6 mt-4">
                            <BasicButton eventClick={getLista} icon="ri-search-line" children={"Buscar"} />
                        </div>
                    </>
                }

                <div className="col-md-12">
                    <BasicTable rowSet={setBean} listButtons={ublInvoiceActionButtons} head={ublInvoiceHead} body={lista} iconButtons={iconButtonsItem} records={paginador} customRows={registers} />
                    <Modal modal={importUBL.modal} updateModal={importUBL.setModal}>
                        <ImportUBLInvoice _multipleUBLs={true} _onChange2={()=>{importUBL.close();getLista();}} entry="Accounting" typeDocument="Supplier" />
                    </Modal>
                </div>
            </div>

            <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { validateData() }} onSubmitLabel={bean.IDUBLInvoice ? "Editar Factura de Proveedor" : null}>
                {formUBL()}
            </Modal>

            {ublInvoiceActionModals}

        </BasicPage>
    )
}
